import { render, staticRenderFns } from "./Cuenta_detalles.vue?vue&type=template&id=761ba0f6"
import script from "./Cuenta_detalles.vue?vue&type=script&lang=js"
export * from "./Cuenta_detalles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports